'use strict';

const OFFERED_POLICIES_SESSION_KEY = 'policiesOffered';
const ADDED_POLICIES_SESSION_KEY = 'policiesAdded';

const pageOrder = {
    desktop: ['details', 'ancillaries', 'payment'],
    mobile: ['passengersinfo', 'canx', 'insurance', 'flex', 'additions', 'selection', 'servicepack', 'payment'],
};

function getTracker(name) {
    return require('./ancillaries')(name);
}

function getPagesToTrack(pageName) {
    const pages = pageOrder[Odigeo.SessionScope.flow];
    return Odigeo._.take(pages, Odigeo._.indexOf(pages, pageName) + 1);
}

function filterPoliciesToTrack(policies) {
    return Odigeo._.filter(policies, (policy) => {
        return isPolicyAdded(policy);
    });
}

function getItemSession(item) {
    return Odigeo.Utils.parseJson(Odigeo.Storage.get(item)) || {};
}

function setItemSession(key, value) {
    Odigeo.Storage.set(key, JSON.stringify(value));
}

function isPolicyAdded(policy) {
    return Odigeo._.some(getItemSession(ADDED_POLICIES_SESSION_KEY), Odigeo._.partial(Odigeo._.includes, _, policy));
}

function getProductsToTrack(pageName) {
    const products = {};
    const pages = getPagesToTrack(pageName);
    const policiesOffered = getItemSession(OFFERED_POLICIES_SESSION_KEY);
    Odigeo._.each(pages, (page) => {
        Odigeo._.forIn(policiesOffered[page], (policies, product) => {
            let added = filterPoliciesToTrack(policies);
            added = Odigeo._.union(added, products[product]);
            Odigeo._.set(products, product, added);
        });
    });
    return products;
}

module.exports.registerOfferedPolicy = function(product, policy, pageName) {
    const policiesOffered = getItemSession(OFFERED_POLICIES_SESSION_KEY);
    let list = Odigeo._.get(policiesOffered, [pageName, product], []);
    list = Odigeo._.union(list, Odigeo._.isArray(policy) ? Odigeo._.compact(policy) : [policy]);
    Odigeo._.set(policiesOffered, [pageName, product], list);
    setItemSession(OFFERED_POLICIES_SESSION_KEY, policiesOffered);
};

module.exports.getRegisteredOfferedPolicies = function(pageName) {
    const policiesOffered = getItemSession(OFFERED_POLICIES_SESSION_KEY);
    return Odigeo._.get(policiesOffered, pageName);
};

module.exports.track = function(pageName, policiesAddedInPage, pageOfPoliciesAdded) {
    const policiesAdded = getItemSession(ADDED_POLICIES_SESSION_KEY);
    policiesAdded[pageOfPoliciesAdded || pageName] = Odigeo._.compact(policiesAddedInPage);
    setItemSession(ADDED_POLICIES_SESSION_KEY, policiesAdded);
    const productsToTrack = getProductsToTrack(pageName);
    Odigeo._.forIn(productsToTrack, (policies, product) => {
        getTracker(product).continue(policies, pageName);
    });
};

module.exports.resetPolicySession = function() {
    Odigeo._.forEach([ADDED_POLICIES_SESSION_KEY, OFFERED_POLICIES_SESSION_KEY], (value) => {
        if (!Odigeo._.isNull(Odigeo.Session.get(value))) {
            Odigeo.Session.storage.removeItem(value);
        }
    });
};
